import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const RadioItem = ({
  preventPropagation = false,
  children,
  ...rest
}) => {
  if (preventPropagation) {
    return (
      <span
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Radio
          {...rest}
        >
          {children}
        </Radio>
      </span>
    );
  }

  return (
    <Radio
      {...rest}
    >
      {children}
    </Radio>

  );
};

RadioItem.propTypes = {
  preventPropagation: PropTypes.bool,
  children: PropTypes.node,
};

export default RadioItem;
